/*
 * Copyright (c) Nexign, JSC, 2021.
 */
/**
 *
 *
 * @author Julia Ignatieva
 * @version 1.16.0
 * @since 1.16.0
 */

import produce from 'immer';
import { Reducer } from 'redux';

import { TWizardImportPersonalDataActions } from './types/wizardImportPersonalDataActionTypes';
import { IWizardImportPersonalDataValidation } from './types/wizardImportPersonalDataTypes';
import {
    initWizardImportPersonalDataState, WIZARD_IMPORT_PERSONAL_DATA_ATTACH_FILE_SUCCESSFUL,
    WIZARD_IMPORT_PERSONAL_DATA_SET_PARAMS,
    WIZARD_IMPORT_PERSONAL_DATA_SET_STEP_VALID,
} from './wizardImportPersonalDataConstant';

export interface IWizardImportPersonalDataReducer {
    errorCode: string;
    errorRowsAmount: number;
    fileName: string;
    fileRowsAmount: number;
    fileTemplateUrl: string;
    maxImportSubscriberAmount: number;
    removedRowsAmount: number;
    resultFileId: string;
    validation: IWizardImportPersonalDataValidation;
}

const wizardImportPersonalDataReducer: Reducer<IWizardImportPersonalDataReducer, TWizardImportPersonalDataActions> =
    (state = initWizardImportPersonalDataState, action: TWizardImportPersonalDataActions) =>
        produce(state, draft => {
            switch (action.type) {
                case WIZARD_IMPORT_PERSONAL_DATA_SET_PARAMS:
                    Object.assign(draft, { ...draft, ...action.payload });
                    break;
                case WIZARD_IMPORT_PERSONAL_DATA_SET_STEP_VALID:
                    draft.validation.isValid = action.payload.isStepValid;
                    draft.validation.error = action.payload.validateError;
                    break;
                case WIZARD_IMPORT_PERSONAL_DATA_ATTACH_FILE_SUCCESSFUL:
                    draft.fileName = action.payload.fileName;
                    draft.fileRowsAmount = action.payload.fileRowsAmount;
                    draft.resultFileId = action.payload.resultFileId;
                    draft.errorCode = '';
                    break;
            }
        });

export default wizardImportPersonalDataReducer;
